// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__p_5Fw","progress":"Placeholder_progress__yy_Cj","bar":"Placeholder_bar__1c6Dj"};